import { togglePlayPause } from '@store/audio/AudioEngineHTML5';
import { setPlaylistUpNext } from '@store/audio/AudioFetcher';

export const formatTime = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60) || 0;
  const seconds = Math.floor(totalSeconds) - minutes * 60 || 0;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export const playTrackInPlaylist = ({
  tablet,
  trackId,
  isActiveTrack,
  event,
  playlistId,
}: {
  tablet: boolean;
  trackId: string;
  isActiveTrack?: boolean;
  event: React.MouseEvent;
  playlistId: string;
}) => {
  // require double click for tablet or larger
  if (tablet && event.detail !== 2) return;

  if (!isActiveTrack) {
    setPlaylistUpNext(playlistId, trackId);
  } else {
    togglePlayPause();
  }
};
